'use strict';

var dom = require('spa-dom'),
    tag = dom.tag;


/**
 * Change server data to list data.
 *
 * @param {Array} data - data for prepare
 *
 * @return {Array} ready data for LayoutList
 */
module.exports = function ( data ) {
    var result = [],
        $backgroundFocus, $backgroundBlur,
        $focusWrapper, $blurWrapper;

    data.forEach(function ( item ) {
        $backgroundFocus = tag('div', {className: 'screenshot'});
        $backgroundBlur = tag('div', {className: 'screenshot'});
        $focusWrapper = tag('div', {className: 'focusWrapper'}, $backgroundFocus);
        $blurWrapper = tag('div', {className: 'blurWrapper'}, $backgroundBlur);
        $backgroundFocus.style.backgroundImage = 'url(' + item + ')';
        $backgroundBlur.style.backgroundImage = 'url(' + item + ')';

        result.push({
            items: [
                $focusWrapper,
                $blurWrapper
            ],
            value: item
        });
    });

    return result;
};
